import { Component, OnInit, Input } from '@angular/core';
import { NotificationPopupComponent } from '../notification-popup/notification-popup.component';
import { PopupNotificationService } from '../../../Services/popup-notification.service';
import { PopupButton, PopupModel, PopupModelReturn, Staff, MenuItems } from '../../../AllTableClasses';
import { Router } from '@angular/router';
import UserSession from '../../../Config/user-session';
import { StaffService } from '../../../Services/staff.service';
import { ChangeDetectorRef } from '@angular/core';
import { AccountService } from '../../../Services/account.service';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss']
})
export class NavigationBarComponent implements OnInit {
  public OpenSideMenu: boolean = false;
  @Input() showNavbar!: boolean;
  public UserName: string = UserSession.UserGuid;
  public staffMember: Staff = new Staff();
  public menuItems: MenuItems[] = [];
  public loading: boolean = false;

  constructor(
    private popupNotificationService: PopupNotificationService,
    private accountService: AccountService,
    private router: Router,
    private staffService: StaffService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (this.showNavbar) {
      this.menuItemsGetByRoleID();
    }
    this.StaffMemberGetByGuid();
  }

  public SideMenuToggle() {
    let navbar = document.querySelector('.navigation-component');
    switch (this.OpenSideMenu) {
      case true:
        this.OpenSideMenu = false;
        navbar?.classList.remove('OpenSideMenu');
        break;
      case false:
        this.OpenSideMenu = true;
        navbar?.classList.add('OpenSideMenu');
        break;
    }
  }

  public StaffMemberGetByGuid() {
    this.staffService.StaffGetByGuid(UserSession.UserGuid, (data) => {
      if (data.Success) {
        this.staffMember = data.Data;
        if (this.staffMember.Name) {
          this.staffMember.Name = this.staffMember.Name + ', ' + this.staffMember.Surname;
          UserSession.UserFullName = this.staffMember.Name;
        }
      }
      else {
        console.log("Error: ", data.UserErrorMessage);
      }
    }, (error) => { });
  }

  menuItemsGetByRoleID() {
    this.staffService.menuItemsGetByRoleID(UserSession.RoleID, (response) => {
      if (response.Success) {
        this.menuItems = JSON.parse(response.Data) as MenuItems[];
      }
    }, (error) => { });
  }

  public Logout() {
    let popup: PopupModel = new PopupModel();
    popup.Message = 'Are you sure you want to Logout';
    popup.MessageType = 'info';
    popup.Button = new PopupButton('Logout', 'Logout');

    this.popupNotificationService.ShowPopup(popup).then((res: PopupModelReturn) => {
      if (res.Result === 'Logout')
      {
        this.removeMemberSessionCookie()
        setTimeout(() => {
          this.router.navigate(['login'], { queryParams: { rememberMe: false } });
        }, 1000);
      }
    });
  }

  removeMemberSessionCookie() {
    this.accountService.removeMemberSessionCookie((data) => {

    }, (error) => { });
  }
}
